
import { defineComponent } from "vue";
import { clientServices } from "../clientServices.service";
import { ToastFactory } from "@/utils/ToastFactory";
const financial = new clientServices();

export default defineComponent({
  name: "BuyCredits",
  data() {
    return {
      creditQtd: 0 as number,
      coupomCode: "" as string,
      coupomFail: false as boolean,
      checkCupomMessenge: "" as string,
      showMessage: false as boolean,
      visible: false,
      currentBalance: 0 as number,
    };
  },
  methods: {
    async getCurrentBalance() {
      await financial.getBalanceUser().then((response: any) => {
        this.currentBalance = response.currentCredit;
      });
    },

    async sendPayment() {
      await financial.createPayment(this.creditQtd).then((response) => {
        window.open(
          `https://www.mercadopago.com.br/checkout/v1/redirect?pref_id=${response.referenceCheckout}`,
          "_blank"
        );
        this.$router.push({ name: "PaymentHistorys" });
      });
    },

    async applyCoupon(): Promise<any> {
      await financial
        .getCheckCoupon(this.coupomCode)
        .then((response) => {
          this.showMessage = true;
          this.coupomFail = false;
          this.checkCupomMessenge = this.$t("financial.applied");
        })
        .catch((error) => {
          this.showMessage = true;
          this.coupomFail = true;
          this.checkCupomMessenge = this.$t("financial.invalid");
        });
    },

    async finishOperation(): Promise<void> {
      await financial
        .createPaymentCoupon(this.coupomCode)
        .then((response) => {
          this.visible = false;
          this.$router.push({ name: "PaymentHistorys" });
          this.$toast.add(ToastFactory.success(this.$t("toast.creditsAdded")));
        })
        .catch((error) => {
          this.$toast.add(
            ToastFactory.error(this.$t("toast.errorCreditsAdded"))
          );
        });
    },

    cancelOperation() {
      this.coupomCode = "";
      this.creditQtd = 0;
      this.$router.back();
    },
  },
  mounted() {
    this.getCurrentBalance();
  },
});
